export class LocalStorageHandler {
  private readonly prefix: string

  constructor(prefix: string = 'wt:') {
    this.prefix = prefix
    if (typeof window === 'undefined') return
  }

  private getPrefixedKey(key: string): string {
    return this.prefix + key
  }

  setItem<T>(key: string, value: T): void {
    const prefixedKey = this.getPrefixedKey(key)
    localStorage.setItem(prefixedKey, JSON.stringify(value))
  }

  getItem<T>(key: string): T | null {
    const prefixedKey = this.getPrefixedKey(key)
    const serializedValue = localStorage.getItem(prefixedKey)
    return serializedValue ? (JSON.parse(serializedValue) as T) : null
  }

  removeItem(key: string): void {
    const prefixedKey = this.getPrefixedKey(key)
    localStorage.removeItem(prefixedKey)
  }

  exists(key: string): boolean {
    const prefixedKey = this.getPrefixedKey(key)
    return localStorage.getItem(prefixedKey) !== null
  }

  clearAll(): void {
    const prefixedKeys = Object.keys(localStorage).filter((key) =>
      key.startsWith(this.prefix),
    )
    prefixedKeys.forEach((key) => localStorage.removeItem(key))
  }

  getKeys(): string[] {
    const prefixedKeys = Object.keys(localStorage).filter((key) =>
      key.startsWith(this.prefix),
    )
    return prefixedKeys.map((key) => key.replace(this.prefix, ''))
  }
}
